import { ABP, CORE_OPTIONS, EnvironmentService } from "@abp/ng.core";
import { registerLocale } from "@abp/ng.core/locale";
import { APP_INITIALIZER, Injector, NgModule } from "@angular/core";
import { environment } from "src/environments/environment";

function coreOptionsFactory({ ...options }: ABP.Root) {
    return {
        ...options,
    } as ABP.Root;
}

const AbpProviders = [
    {
        provide: 'CORE_OPTIONS',
        useValue: {
            environment: environment,
            registerLocaleFn: registerLocale(),
        } as ABP.Root,
    },
    {
        provide: CORE_OPTIONS,
        useFactory: coreOptionsFactory,
        deps: ['CORE_OPTIONS']
    },
    {
        provide: APP_INITIALIZER,
        useFactory: (injector: Injector) => {
            return () => {
                const envService = injector.get(EnvironmentService);
                envService.setState(environment);
                return Promise.resolve();
            }
        },
        multi: true,
        deps: [Injector]
    },
]

@NgModule({
    providers: AbpProviders
})
export default class AbpProvidersModule {

}